import { Input,  Directive, HostBinding } from '@angular/core';
import { BootstrapColor } from '../../global-types';

export type BpTableBorder = 'borderless' | 'default' | 'bordered';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[bpTable], [bpTbl]',
  exportAs: 'bpTable'
})
// tslint:disable-next-line:component-class-suffix
export class BpTableDirective {
  @Input() color: BootstrapColor;
  @Input() border: BpTableBorder = 'default';
  @Input() striped: boolean;
  @Input() hoverable: boolean;
  @Input() small: boolean;

  @HostBinding('class') get _class() {
    let cls = 'table';
    if (this.color) {
      cls += ` table-${this.color}`;
    }
    if (this.striped) {
      cls += ' table-striped';
    }
    if (this.hoverable) {
      cls += ' table-hover';
    }
    if (this.small) {
      cls += ' table-sm';
    }
    if (this.border === 'bordered') {
      cls += ' table-bordered';
    } else if (this.border === 'borderless') {
      cls += ' table-table-borderless';
    }

    return cls;
  }
}

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[bpTableHead], [bpThead]',
  exportAs: 'bpTableHead'
})
// tslint:disable-next-line:component-class-suffix
export class BpTableHeadDirective {
  @Input() color: BootstrapColor;

  @HostBinding('class') get _class() {
    let cls = '';
    if (this.color) {
      cls = `thead-${this.color}`;
    }
    return cls;
  }
}
